import React, { useState } from 'react';
import { SocialSharing } from '@ionic-native/social-sharing';

import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonCard,
  IonCardSubtitle,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonBadge,
  IonToast,
  IonLoading,
} from '@ionic/react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as actionCreator from '../store/actions/orderActions';
import _ from 'lodash';

import FloatingActionButton from '../components/FloatingActionButton';

export const ItemDetailsContainer: React.FC = (props: any) => {
  const { list, userDbInfo } = props;
  const { id } = useParams();
  const item = _.cloneDeep(_.find(list, { _id: id }));

  const [showGetLink, setGetLink] = useState(false);
  let nav: any;
  nav = window.navigator;
  if (nav && !nav.share) {
    setTimeout(() => {
      setGetLink(true);
    }, 3000);
  }

  //handle toast
  const [showToast, setShowToast] = useState(false);

  if (!item) {
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  const handleShare = async () => {
    const shop = userDbInfo.shopName || 'Mosi';
    const shareData = {
      title: item.name,
      text: `Buy your ${item.name} from ${shop}`,
      url: `https://mosi-nextjs-checkout-page.vercel.app/items/${id}`,
    };

    let nav: any;
    nav = window.navigator;
    try {
      await nav.share(shareData);
      // if (nav && nav.share) {
      //   await nav.share(shareData);
      // } else {
      //   console.log('Share not supported');
      //   nav.clipboard.writeText(shareData.url);
      //   setShowToast(true);
      //   setGetLink(true);
      // }
    } catch (e) {
      console.log(e);
    }

    // try {
    //   SocialSharing.share('', shareData.title, [shareData.url]);
    // } catch (e) {
    //   console.log(e);
    // }
  };

  return (
    <IonPage className="order-page">
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>{item.name}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <img src={item.imageURL} alt="item" />
          <IonCardHeader>
            <IonCardSubtitle>KES {item.price}</IonCardSubtitle>
            <IonCardTitle>{item.name}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            {item.description || 'No description'}
          </IonCardContent>
        </IonCard>

        <IonItem>
          <IonLabel>
            <h4>In Stock</h4>
          </IonLabel>
          <IonBadge slot="end" color="primary">
            {item.quantity_available}
          </IonBadge>
        </IonItem>

        <IonItem>
          <IonLabel>
            <h4>Number of sales</h4>
          </IonLabel>
          <IonBadge slot="end" color="warning">
            {item.saleCount}
          </IonBadge>
        </IonItem>

        <IonButton expand="block" onClick={() => handleShare()}>
          {showGetLink ? 'Get Shareable Link' : 'Share'}
        </IonButton>
      </IonContent>
      <FloatingActionButton children={'/editItem/' + id} />
      <IonToast
        isOpen={showToast}
        message="Link Copied"
        onDidPresent={() => setShowToast(false)}
        duration={9000}
        position="top"
      />
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.inventoryReducer.list,
    userDbInfo: state.userReducer.userDbInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemDetailsContainer);
